/* "Forest & Champagne" — deep forest green + ivory + champagne gold.
   Inspired by: Hermès, Penguin Classics, Soho House library. */
import PremiumLandingShell from "@/pages/PremiumLandingShell";

const THEME = {
  id: "forest",
  name: "forest & champagne",
  bg: "#0F1F18",      // deep forest
  ink: "#F2E9D5",     // warm ivory
  seal: "#D4B373",    // champagne gold
};

export default function LandingForest() {
  return <PremiumLandingShell theme={THEME} />;
}
